import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { LightButton } from '../../common/fromAuth/LightButton/LightButton';
import { LightIcon } from '../../common/fromAuth/LightIcon/LightIcon';
import { LightText } from '../../common/fromAuth/LightText/LightText';
import { PromoRow } from '../../common/PromoRow/PromoRow';

const EmptyContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex: 1;
`;

export const PromoEmptyPage = (props) => {
    return (
        <EmptyContainer>
            <PromoRow indent="16px">
                <LightIcon name={'ghost'} color="mediumGray" useThemeColor={props.useThemeColor} />
            </PromoRow>
            <PromoRow indent={props.showChat ? '16px' : '0'}>
                <LightText color="mediumGray" useThemeColor={props.useThemeColor}>
                    {props.notFoundMessage}
                </LightText>
            </PromoRow>
            {props.showChat && (
                <LightButton
                    useThemeColor={props.useThemeColor}
                    caption={props.chatButton}
                    variant={'row'}
                    type={props.chatButtonType ? props.chatButtonType : 'button'}
                    href={props.chatButtonHref ? props.chatButtonHref : null}
                    onClick={props.toggleChat}
                    negativeMargin
                    id={props.buttonId}
                />
            )}
        </EmptyContainer>
    );
};

PromoEmptyPage.propTypes = {
    notFoundMessage: PropTypes.string,
    chatButtonType: PropTypes.string,
    chatButtonHref: PropTypes.string,
};
